// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './plugs/router'
import store from './plugs/vuex'
import utils from './plugs/utils'
import i18n from './plugs/i18n'
import AOS from 'aos'
import 'aos/dist/aos.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import './plugs/axios'

// import 'amfe-flexible';



Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(ElementUI);
utils.initRem(document,window)
AOS.init();
Vue.config.productionTip = false

// Vue.prototype.imgUrl = process.env.NODE_ENV !== 'production' ? '' : '',
Vue.prototype.imgUrl = process.env.NODE_ENV !== 'production' ? '' : 'https://files.chaunve.com/wwwchaunvecom/',


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
  computed: {
		lan:function(){
			return this.$store.state.lan;
		},
	},
  watch:{
		$route(to,from){
			document.documentElement.scrollTop=document.body.scrollTop=0;
		},
		lan:function(data){
			console.log('watchLan',data);
			this.$i18n.locale=data;
		},
	},
})
var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
 (function () {
       var hm = document.createElement("script");
	   hm.src = "https://hm.baidu.com/hm.js?4b926b5e65e0c108bc586ca191337afa";
       var s = document.getElementsByTagName("script")[0];
       s.parentNode.insertBefore(hm, s);
  })();
{/* <script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?4b926b5e65e0c108bc586ca191337afa";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script> */}


// WEBPACK FOOTER //
// ./src/main.js